import { Extension } from '@tiptap/core';

/**
 * Renders the `blockId` node attribute as `data-block-id` in the DOM
 * for all block-level node types. This allows querySelector-based
 * navigation (e.g. scrolling to a specific block from suggestion cards).
 *
 * Without this extension, only ImageExtension renders data-block-id;
 * paragraphs/headings from StarterKit silently drop the attribute.
 */
export const BlockIdAttribute = Extension.create({
	name: 'blockIdAttribute',

	addGlobalAttributes() {
		return [
			{
				types: [
					'paragraph',
					'heading',
					'bulletList',
					'orderedList',
					'blockquote',
					'table',
					'callout',
					'faqSchema',
					'statsGrid',
				],
				attributes: {
					blockId: {
						default: null,
						parseHTML: (element) =>
							element.getAttribute('data-block-id'),
						renderHTML: (attributes) => {
							if (!attributes.blockId) return {};
							return { 'data-block-id': attributes.blockId };
						},
					},
				},
			},
			{
				types: ['heading'],
				attributes: {
					id: {
						default: null,
						parseHTML: (element) => element.getAttribute('id'),
						renderHTML: (attributes) => {
							if (!attributes.id) return {};
							return { id: attributes.id };
						},
					},
					'data-toc-id': {
						default: null,
						parseHTML: (element) => element.getAttribute('data-toc-id'),
						renderHTML: (attributes) => {
							if (!attributes['data-toc-id']) return {};
							return { 'data-toc-id': attributes['data-toc-id'] };
						},
					},
				},
			},
		];
	},
});
